/** No-op — query params are forwarded via URL, no localStorage needed */
export const LandingEffects = () => <></>;
